import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import ReactHtmlParser from 'react-html-parser';
import App from "./components/app/App";

const B2bBootstrap = React.lazy(() => import('./b2b-bootstrap-component'));

const B2bBootstrapLoader = ({children}) => {
    return (
        <>
            <React.Suspense fallback={<></>}>
                {<B2bBootstrap/>}
            </React.Suspense>
            {children}
        </>
    )
}

let errors = [];
let headerContent;
let footerContent;

// get franchiseData from the swap endpoint...
const franchiseData = fetch('/wthrest/customer-self-service/getFranchiseData.rs').then(response => response.json()).catch(error => {
    errors.push("Error getting franchiseData from swap...");
    errors.push(error)
}).catch(error => {
    errors.push("Error getting franchiseData from swap...");
    errors.push(error);
});

//get siteConfig from the swap endpoint...
const siteConfigData = fetch('/wthrest/customer-self-service/getSiteConfig.rs').then(response => response.json()).catch(error => {
    errors.push("Error getting siteConfigData from swap...");
    errors.push(error)
}).catch(error => {
    errors.push("Error getting siteConfigData from swap...");
    errors.push(error);
});

const loadB2bStyles = () => {
    const mainSiteDomain = document.location.hostname.split('.')[1];
    if (mainSiteDomain.toLowerCase().indexOf("cruiseone") > -1 || mainSiteDomain.toLowerCase().indexOf("cruisesit") > -1) {
        appendChildForCss('stylesheet', 'text/css', '/includes/desktop/css/desktop_d1.css');
        appendChildForCss('stylesheet', 'text/css', '/images/hbapp/css/CONEstyle.css');
        appendChildForCss('shortcut icon', 'image/ico', '/images/home-based/websites/logos/favicon_cone.ico');
    } else if (mainSiteDomain.toLowerCase().indexOf("cruisesinc") > -1) {
        appendChildForCss('stylesheet', 'text/css', '/images/hbapp/css/CINCstyle.css');
        appendChildForCss('stylesheet', 'text/css', '/includes/desktop/css/desktop_f1.css');
        appendChildForCss('shortcut icon', 'image/ico', '/images/home-based/websites/logos/favicon_cinc.ico');
    } else if (mainSiteDomain.toLowerCase().indexOf("dreamvacations") > -1 || mainSiteDomain.toLowerCase().indexOf("travelperks") > -1) {
        appendChildForCss('stylesheet', 'text/css', '/images/hbapp/css/DVstyle.css');
        appendChildForCss('stylesheet', 'text/css', '/includes/desktop/css/desktop_m1.css');
        appendChildForCss('stylesheet', 'text/css', 'https://fonts.googleapis.com/css?family=Oswald:400,700');
        appendChildForCss('stylesheet', 'text/css', 'https://fonts.googleapis.com/css?family=Open+Sans:400,700');
        appendChildForCss('shortcut icon', 'image/ico', '/images/home-based/websites/logos/favicon_dv.ico');
    }
}

const appendChildForCss = (rel, type, href) => {
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');

    link.rel = rel;
    link.type = type;
    link.href = href;

    head.appendChild(link);
}

Promise.all([franchiseData, siteConfigData]).then((response) => {
    if (errors.length === 0) {

        let franchiseData = response[0];
        let siteConfigData = response[1];

        let oneTrustSiteValue = siteConfigData.siteProperties.filter(function(onetrustName, index) {
			
            if (onetrustName.propertyName === 'ONE_TRUST_SNIPPET_COOKIE_LOADER') {
                return onetrustName;
            }
            else{
				return null;
			}
        })

        // onetrust first script
        if (oneTrustSiteValue[0].propertyValue !== 'N') {
            const scriptTag = document.createElement("script");
            scriptTag.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
            scriptTag.type = "text/javascript";
            scriptTag.setAttribute('charset', 'UTF-8');
            scriptTag.setAttribute("data-domain-script", oneTrustSiteValue[0].propertyValue); 
            const head = document.getElementsByTagName("head")[0]
            head.insertBefore(scriptTag, head.firstChild);
    
            // onetrust second script
            const scriptElement = document.createElement('script');
            scriptElement.type = "text/javascript";
            scriptElement.innerHTML = `function OptanonWrapper(){}`;
            head.appendChild(scriptElement);

            scriptTag.onload = () => {
                initializeApp(franchiseData, siteConfigData);
            };

            scriptTag.onerror = () => {
                console.error("Failed to load OneTrust script.");
                initializeApp(franchiseData, siteConfigData);
            };
        }else{
            initializeApp(franchiseData, siteConfigData);
        }

    } else {
        console.log(errors);
    }
});

const loadScripts = (scripts) => {
    scripts.forEach((script) => {
        if (script?.attribs?.src) {
            const scriptElement = document.createElement('script');
            scriptElement.src = script.attribs.src;
            scriptElement.async = true;
            document.head.appendChild(scriptElement);
        }
    });
};

function initializeApp(franchiseData, siteConfigData) {
    let isSwapSite = null;
    if (Object.keys(franchiseData).length <= 0 && Object.keys(siteConfigData).length > 0) {
        isSwapSite = true;
    } else {
        isSwapSite = false;
    }
    if (franchiseData.redirectToWebsite != null && franchiseData.redirectToWebsite !== '') {
        let newUrl = window.location.protocol + '//' + franchiseData.redirectToWebsite + window.location.pathname;
        window.location = newUrl;
    } else {

        // get header from the swap endpoint...
        const options = {
                mode: 'cors',
                headers: new Headers({'content-type': 'text/html; charset=UTF-8'})
            };

        const headerFetch = fetch('/wthrest/customer-self-service/getHeader.rs', options)
           .then(response => response.text())
           .then(content => {
           headerContent = content;
        })
          .catch(error => {
            errors.push("Error getting header from swap...");
            errors.push(error);
         });

        // get footer from the swap endpoint...
        const footerFetch = fetch('/wthrest/customer-self-service/getFooter.rs', options).then(response => response.text()).then(content => {
            footerContent = content;
        }).catch(error => {
            errors.push("Error getting footer from swap...");
            errors.push(error)
        }).catch(error => {
            errors.push("Error getting footer from swap...");
            errors.push(error)
        });

        if (errors.length === 0) {
            // wait for header, footer and franchise data to be resolved and then continue loading tha page...
            Promise.all([headerFetch, footerFetch]).then((response) => {
                ReactDOM.render(
                    (!isSwapSite &&
                    <B2bBootstrapLoader>
                        <App franchiseData={franchiseData} siteConfigData={siteConfigData} isSwapSite={isSwapSite}/>
                    </B2bBootstrapLoader>) ||
                    <App franchiseData={franchiseData} siteConfigData={siteConfigData} isSwapSite={isSwapSite}/>
                    , document.getElementById('root'));
                loadB2bStyles();
                ReactDOM.render(
                    <div>
                        { isSwapSite===true &&
                        //eslint-disable-next-line
                            <a href="javascript:void(0);" id="skipToMainContent" class="wth2-skipToMain">Skip to content <span class="visuallyhidden">Press Enter</span></a>
                        }
                        {ReactHtmlParser(headerContent, {
                                transform: (node, index) => {
                                    if (node.type === 'script' && node?.attribs?.src) {
                                        // Handle external scripts
                                        loadScripts([node]);
                                        return null;
                                    }
                                },
                            }
                        )} </div>
                    , document.getElementById('header'));
                ReactDOM.render(
                    <div>
                         {ReactHtmlParser(footerContent, {
                                transform: (node, index) => {
                                    if (node.type === 'script' && node?.attribs?.src) {
                                        // Handle external scripts
                                        loadScripts([node]);
                                        return null;
                                    }
                                },
                            }
                        )} </div>
                    , document.getElementById('footer'));
            }).catch(error => {
                errors.push(error)
            }).catch(error => {
                errors.push(error)
            });
        } else {
            console.log(errors);
        }
    }
}
serviceWorker.unregister();
